import { render, staticRenderFns } from "./CaptchaControl.vue?vue&type=template&id=51034c00&scoped=true"
import script from "./CaptchaControl.vue?vue&type=script&lang=js"
export * from "./CaptchaControl.vue?vue&type=script&lang=js"
import style0 from "./CaptchaControl.vue?vue&type=style&index=0&id=51034c00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51034c00",
  null
  
)

export default component.exports